(function ($, showShellUi, startWithoutClientSettings) {

    'use strict';

    $(function () {

        RivalIQ.apps.Shell.initializeAndStart({
            showShellUi: showShellUi,
            startWithoutClientSettings: startWithoutClientSettings
        });
    });

}(window.jQuery, window.showShellUi, Boolean(window.startWithoutClientSettings)));
